/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Geofence } from "../../../../util/geofence/geofence";
import { AdsbRegulatoryManagerSettings } from "../../../adsb_regulatory_manager/adsb_regulatory_manager";
import { ReturnSettings } from "../../../infrastructure/flight_deck/return_settings";

export const protobufPackage = "skills";

export interface FloatSetting {
  field: string;
  value: number;
}

export interface BoolSetting {
  field: string;
  value: boolean;
}

export interface EnumSetting {
  field: string;
  value: number;
}

export interface UpdateVehicleSettingsActionArgs {
  /** Basic setting types */
  boolSettings: BoolSetting[];
  floatSettings: FloatSetting[];
  /** NOTE(nathan): This includes, e.g., NavigationMode.Mode and ObstacleMarginMode */
  enumSettings: EnumSetting[];
  /** Settings with custom message definitions. */
  returnSettings: ReturnSettings | undefined;
  geofence: Geofence | undefined;
  adsbRegulatoryManagerSettings: AdsbRegulatoryManagerSettings | undefined;
}

export interface UpdateVehicleSettingsResultData {
}

export interface UpdateVehicleSettingsActionStateData {
}

function createBaseFloatSetting(): FloatSetting {
  return { field: "", value: 0 };
}

export const FloatSetting = {
  encode(message: FloatSetting, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.field !== "") {
      writer.uint32(10).string(message.field);
    }
    if (message.value !== 0) {
      writer.uint32(21).float(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FloatSetting {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseFloatSetting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.field = reader.string();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.value = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): FloatSetting {
    return {
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: FloatSetting): unknown {
    const obj: any = {};
    if (message.field !== "") {
      obj.field = message.field;
    }
    if (message.value !== 0) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<FloatSetting>, I>>(base?: I): FloatSetting {
    return FloatSetting.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<FloatSetting>, I>>(object: I): FloatSetting {
    const message = createBaseFloatSetting();
    message.field = object.field ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseBoolSetting(): BoolSetting {
  return { field: "", value: false };
}

export const BoolSetting = {
  encode(message: BoolSetting, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.field !== "") {
      writer.uint32(10).string(message.field);
    }
    if (message.value === true) {
      writer.uint32(16).bool(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): BoolSetting {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBoolSetting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.field = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.value = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BoolSetting {
    return {
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      value: isSet(object.value) ? globalThis.Boolean(object.value) : false,
    };
  },

  toJSON(message: BoolSetting): unknown {
    const obj: any = {};
    if (message.field !== "") {
      obj.field = message.field;
    }
    if (message.value === true) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BoolSetting>, I>>(base?: I): BoolSetting {
    return BoolSetting.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BoolSetting>, I>>(object: I): BoolSetting {
    const message = createBaseBoolSetting();
    message.field = object.field ?? "";
    message.value = object.value ?? false;
    return message;
  },
};

function createBaseEnumSetting(): EnumSetting {
  return { field: "", value: 0 };
}

export const EnumSetting = {
  encode(message: EnumSetting, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.field !== "") {
      writer.uint32(10).string(message.field);
    }
    if (message.value !== 0) {
      writer.uint32(16).int32(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EnumSetting {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnumSetting();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.field = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.value = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnumSetting {
    return {
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: EnumSetting): unknown {
    const obj: any = {};
    if (message.field !== "") {
      obj.field = message.field;
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnumSetting>, I>>(base?: I): EnumSetting {
    return EnumSetting.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnumSetting>, I>>(object: I): EnumSetting {
    const message = createBaseEnumSetting();
    message.field = object.field ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseUpdateVehicleSettingsActionArgs(): UpdateVehicleSettingsActionArgs {
  return {
    boolSettings: [],
    floatSettings: [],
    enumSettings: [],
    returnSettings: undefined,
    geofence: undefined,
    adsbRegulatoryManagerSettings: undefined,
  };
}

export const UpdateVehicleSettingsActionArgs = {
  encode(message: UpdateVehicleSettingsActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.boolSettings) {
      BoolSetting.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    for (const v of message.floatSettings) {
      FloatSetting.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.enumSettings) {
      EnumSetting.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    if (message.returnSettings !== undefined) {
      ReturnSettings.encode(message.returnSettings, writer.uint32(98).fork()).ldelim();
    }
    if (message.geofence !== undefined) {
      Geofence.encode(message.geofence, writer.uint32(106).fork()).ldelim();
    }
    if (message.adsbRegulatoryManagerSettings !== undefined) {
      AdsbRegulatoryManagerSettings.encode(message.adsbRegulatoryManagerSettings, writer.uint32(114).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateVehicleSettingsActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateVehicleSettingsActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.boolSettings.push(BoolSetting.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.floatSettings.push(FloatSetting.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.enumSettings.push(EnumSetting.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.returnSettings = ReturnSettings.decode(reader, reader.uint32());
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.geofence = Geofence.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.adsbRegulatoryManagerSettings = AdsbRegulatoryManagerSettings.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateVehicleSettingsActionArgs {
    return {
      boolSettings: globalThis.Array.isArray(object?.boolSettings)
        ? object.boolSettings.map((e: any) => BoolSetting.fromJSON(e))
        : [],
      floatSettings: globalThis.Array.isArray(object?.floatSettings)
        ? object.floatSettings.map((e: any) => FloatSetting.fromJSON(e))
        : [],
      enumSettings: globalThis.Array.isArray(object?.enumSettings)
        ? object.enumSettings.map((e: any) => EnumSetting.fromJSON(e))
        : [],
      returnSettings: isSet(object.returnSettings) ? ReturnSettings.fromJSON(object.returnSettings) : undefined,
      geofence: isSet(object.geofence) ? Geofence.fromJSON(object.geofence) : undefined,
      adsbRegulatoryManagerSettings: isSet(object.adsbRegulatoryManagerSettings)
        ? AdsbRegulatoryManagerSettings.fromJSON(object.adsbRegulatoryManagerSettings)
        : undefined,
    };
  },

  toJSON(message: UpdateVehicleSettingsActionArgs): unknown {
    const obj: any = {};
    if (message.boolSettings?.length) {
      obj.boolSettings = message.boolSettings.map((e) => BoolSetting.toJSON(e));
    }
    if (message.floatSettings?.length) {
      obj.floatSettings = message.floatSettings.map((e) => FloatSetting.toJSON(e));
    }
    if (message.enumSettings?.length) {
      obj.enumSettings = message.enumSettings.map((e) => EnumSetting.toJSON(e));
    }
    if (message.returnSettings !== undefined) {
      obj.returnSettings = ReturnSettings.toJSON(message.returnSettings);
    }
    if (message.geofence !== undefined) {
      obj.geofence = Geofence.toJSON(message.geofence);
    }
    if (message.adsbRegulatoryManagerSettings !== undefined) {
      obj.adsbRegulatoryManagerSettings = AdsbRegulatoryManagerSettings.toJSON(message.adsbRegulatoryManagerSettings);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateVehicleSettingsActionArgs>, I>>(base?: I): UpdateVehicleSettingsActionArgs {
    return UpdateVehicleSettingsActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateVehicleSettingsActionArgs>, I>>(
    object: I,
  ): UpdateVehicleSettingsActionArgs {
    const message = createBaseUpdateVehicleSettingsActionArgs();
    message.boolSettings = object.boolSettings?.map((e) => BoolSetting.fromPartial(e)) || [];
    message.floatSettings = object.floatSettings?.map((e) => FloatSetting.fromPartial(e)) || [];
    message.enumSettings = object.enumSettings?.map((e) => EnumSetting.fromPartial(e)) || [];
    message.returnSettings = (object.returnSettings !== undefined && object.returnSettings !== null)
      ? ReturnSettings.fromPartial(object.returnSettings)
      : undefined;
    message.geofence = (object.geofence !== undefined && object.geofence !== null)
      ? Geofence.fromPartial(object.geofence)
      : undefined;
    message.adsbRegulatoryManagerSettings =
      (object.adsbRegulatoryManagerSettings !== undefined && object.adsbRegulatoryManagerSettings !== null)
        ? AdsbRegulatoryManagerSettings.fromPartial(object.adsbRegulatoryManagerSettings)
        : undefined;
    return message;
  },
};

function createBaseUpdateVehicleSettingsResultData(): UpdateVehicleSettingsResultData {
  return {};
}

export const UpdateVehicleSettingsResultData = {
  encode(_: UpdateVehicleSettingsResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateVehicleSettingsResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateVehicleSettingsResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateVehicleSettingsResultData {
    return {};
  },

  toJSON(_: UpdateVehicleSettingsResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateVehicleSettingsResultData>, I>>(base?: I): UpdateVehicleSettingsResultData {
    return UpdateVehicleSettingsResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateVehicleSettingsResultData>, I>>(_: I): UpdateVehicleSettingsResultData {
    const message = createBaseUpdateVehicleSettingsResultData();
    return message;
  },
};

function createBaseUpdateVehicleSettingsActionStateData(): UpdateVehicleSettingsActionStateData {
  return {};
}

export const UpdateVehicleSettingsActionStateData = {
  encode(_: UpdateVehicleSettingsActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateVehicleSettingsActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateVehicleSettingsActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateVehicleSettingsActionStateData {
    return {};
  },

  toJSON(_: UpdateVehicleSettingsActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateVehicleSettingsActionStateData>, I>>(
    base?: I,
  ): UpdateVehicleSettingsActionStateData {
    return UpdateVehicleSettingsActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateVehicleSettingsActionStateData>, I>>(
    _: I,
  ): UpdateVehicleSettingsActionStateData {
    const message = createBaseUpdateVehicleSettingsActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
